export default "__VITE_ASSET__07b563d6__"